// @ts-nocheck

import { useMemo } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { type CustomRouterHistory, type CustomRouterLocation } from '../createHistory';

const useRouter = () => {
  const history: CustomRouterHistory = useHistory();
  const location: CustomRouterLocation = useLocation();
  const params: { [key: string]: unknown } = useParams();

  // eslint-disable-next-line sonarjs/prefer-immediate-return
  const router = useMemo(() => ({ history, location, params }), [history, location, params]);

  return router;
};

export default useRouter;
